module.exports = __webpack_public_path__ + "img/tallasEsquema.d34f54cc.jpeg";